import { Text, Flex, } from "@chakra-ui/react";
import { LeaderData } from "./LeaderJSON";
import Leader from "./Leader";

function Leaderboard() {
  var leaderboard_Live = true;
  
  return (
    <Flex
        width="99vw" 
        minHeight="100vh"
        flexDir="column"
        bg="#171717"
        alignItems="center"
    >
      <Flex 
          flexDir="column" 
          width="80vw"
          height="100%"
          m="auto"
          justifyContent="center"
          alignItems="center"
      >
        {leaderboard_Live ? <>
        <Text 
            color="core.red" 
            fontSize={["32px","32px","32px","96px","96px"]}
            fontWeight="800"
            lineHeight="1"
            m="auto"
            mb="10px"
            mt="60px"
        >Leaderboard</Text>

        {LeaderData.map((item, id) => (
          <Leader
            name={item[1]}
            id={item[0]}
            score={item[2]}
          />
        ))}
        <Flex mb="40px" />
        </> :
        <Text 
          color="core.red" 
          mt="50px"
          fontSize={["52px","52px","52px","72px","72px"]}
          fontWeight="800"
          lineHeight="1"
          mb="20px"
          m="auto"
        >We'll be releasing the results here at 7PM, stay tuned!</Text>
      }
      </Flex>
    </Flex>
  );
}

export default Leaderboard;
